module.exports = __webpack_public_path__ + "media/images/consulta-color-76726dee34f51d2b8f4025479e80064a.png";